import { createSlice } from "@reduxjs/toolkit";
import { getEmployeeList } from "services/employee/employee";

const initialState = {
    employee : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}

export const employeeSlice = createSlice({
    name: 'employee',
    initialState,
    extraReducers: {
        [getEmployeeList.pending]: (state) => {
            state.employee.isLoading = true;
        },
        [getEmployeeList.fulfilled]: (state, { payload }) => {
            state.employee.isLoading = false;
            state.employee.isSuccess = true;
            state.employee.data = payload;
        },
        [getEmployeeList.rejected]: (state, { payload }) => {
            state.employee.isLoading = false;
            state.employee.isSuccess = false;
            state.employee.errorMessage = payload
        }
    }
})

export default employeeSlice.reducer;